module.exports = __webpack_public_path__ + "static/media/RRD6.2bd87c9a.jpg";